import { Button } from "@lumen-energy/design-system"
import { IconX } from "@tabler/icons-react"

import { EditLabelText } from "./EditLabelText"
import { LabelProps } from "./Label"
import { LabelGroupProps } from "./LabelGroup"

export interface EditSiteLabelPopoverContentProps
  extends Pick<
    LabelGroupProps,
    "editLabelColor" | "editLabelName" | "orgLabels" | "removeLabel"
  > {
  label: LabelProps
}

export function EditSiteLabelPopoverContent({
  editLabelColor,
  editLabelName,
  label,
  orgLabels,
  removeLabel,
}: EditSiteLabelPopoverContentProps) {
  return (
    <div>
      <Button
        className="px-2 py-1"
        variant="neutral"
        iconPosition="left"
        icon={IconX}
        onClick={(event) => {
          event.stopPropagation()
          removeLabel(label.pid, label.name)
        }}
        size="small"
        noBorder
      >
        Remove label
      </Button>
      <hr className="mt-2 mb-2 border-colors-border-secondary" />
      <EditLabelText
        editLabelColor={editLabelColor}
        editLabelName={editLabelName}
        labelPid={label.pid}
        initialName={label.name}
        initialThemeColor={label.themeColor}
        orgLabels={orgLabels}
      />
    </div>
  )
}
